import {
  FiHome,
  FiEdit3,
  FiBriefcase,
  FiCompass,
  FiHeart,
  FiFolder,
  FiUsers,
  FiUser,
  FiKey,
  FiTrendingUp,
  FiGrid,
  FiBookOpen,
  FiCreditCard,
  FiLayers,
  FiFileText,
  FiShoppingBag,
  FiCalendar,
  FiMail,
  FiZap,
} from "react-icons/fi";

const createItem = (item) => ({
  ...item,
  activePrefixes: item.activePrefixes ?? [item.to],
});

export const PARTNER_PANEL_HOME = "/partner/workspace";

export const partnerSidebarSections = [
  {
    id: "overview",
    title: "Overview",
    items: [
      {
        to: "/partner/workspace",
        label: "Dashboard",
        icon: FiHome,
        activePrefixes: ["/partner/workspace", "/partner/dashboard", "/partner/myspace"],
      },
      {
        to: "/partner/leads",
        label: "Partner Leads",
        icon: FiFileText,
        activePrefixes: ["/partner/leads"],
      },
      {
        to: "/partner/profile",
        label: "Partner Profile",
        icon: FiUser,
        activePrefixes: ["/partner/profile"],
      },
    ],
  },
  {
    id: "create-publish",
    title: "Create & Publish",
    items: [
      {
        to: "/add-property",
        label: "Add Property",
        icon: FiBriefcase,
        activePrefixes: ["/add-property", "/property/add-property"],
      },
      {
        to: "/add-promotion",
        label: "Create Promotion",
        icon: FiTrendingUp,
        activePrefixes: ["/add-promotion"],
      },
      {
        to: "/post/add-post",
        label: "Create Post",
        icon: FiEdit3,
        activePrefixes: ["/post/add-post"],
      },
    ],
  },
  {
    id: "services-catalog",
    title: "Partner Offerings",
    items: [
      {
        to: "/partner/interior-design",
        label: "Interior Catalogs",
        icon: FiLayers,
        activePrefixes: ["/partner/interior-design"],
      },
      {
        to: "/partner/local-bazaar",
        label: "Local Bazaar Store",
        icon: FiShoppingBag,
        activePrefixes: ["/partner/local-bazaar"],
      },
      {
        to: "/partner/services",
        label: "My Service Offerings",
        icon: FiGrid,
        activePrefixes: ["/partner/services"],
      },
    ],
  },
  {
    id: "tools",
    title: "Business Tools",
    items: [
      {
        to: "/partner/tools",
        label: "Tools Hub",
        icon: FiGrid,
        activePrefixes: ["/partner/tools"],
      },
      {
        to: "/partner/tools/khatabook",
        label: "Khatabook",
        icon: FiBookOpen,
        activePrefixes: ["/partner/tools/khatabook"],
      },
      {
        to: "/partner/tools/cashbook",
        label: "Cashbook",
        icon: FiCreditCard,
        activePrefixes: ["/partner/tools/cashbook"],
      },
      {
        to: "/partner/tools/projects",
        label: "Project Ledger",
        icon: FiLayers,
        activePrefixes: ["/partner/tools/projects"],
      },
      {
        to: "/partner/tools/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/partner/tools/leases", "/partner/leases"],
      },
    ],
  },
  {
    id: "engagements",
    title: "Schedules & Network",
    items: [
      {
        to: "/partner/reminders",
        label: "Meeting Reminders",
        icon: FiCalendar,
        activePrefixes: ["/partner/reminders"],
      },
      {
        to: "/partner/communities",
        label: "Communities Hub",
        icon: FiUsers,
        activePrefixes: ["/partner/communities"],
      },
      {
        to: "/partner/invitations",
        label: "Invitations Hub",
        icon: FiMail,
        activePrefixes: ["/partner/invitations"],
      },
      {
        to: "/partner/teams",
        label: "Partner Teams",
        icon: FiLayers,
        activePrefixes: ["/partner/teams"],
      },
      {
        to: "/partner/network",
        label: "Network Partners",
        icon: FiUsers,
        activePrefixes: ["/partner/network", "/partner/agents"],
      },
      {
        to: "/partner/friends",
        label: "Customers & Friends",
        icon: FiUser,
        activePrefixes: ["/partner/friends"],
      },
    ],
  },
  {
    id: "growth",
    title: "Membership & Growth",
    items: [
      {
        to: "/partner/subscription",
        label: "Current Plan & Upgrades",
        icon: FiZap,
        activePrefixes: ["/partner/subscription"],
      },
    ],
  },
  {
    id: "shared",
    title: "Marketplace & Listings",
    items: [
      {
        to: "/partner/properties",
        label: "Marketplace Listings",
        icon: FiBriefcase,
        activePrefixes: ["/partner/properties"],
      },
      {
        to: "/partner/posts",
        label: "Community Posts",
        icon: FiEdit3,
        activePrefixes: ["/partner/posts"],
      },
      {
        to: "/partner/promotions",
        label: "Shared Promotions",
        icon: FiTrendingUp,
        activePrefixes: ["/partner/promotions"],
      },
      {
        to: "/partner/shared-leads",
        label: "Shared Leads",
        icon: FiCompass,
        activePrefixes: ["/partner/shared-leads"],
      },
    ],
  },
  {
    id: "myspace",
    title: "My Business Space",
    items: [
      {
        to: "/partner/my-properties",
        label: "My Property Listings",
        icon: FiBriefcase,
        activePrefixes: ["/partner/my-properties"],
      },
      {
        to: "/partner/my-posts",
        label: "My Created Posts",
        icon: FiEdit3,
        activePrefixes: ["/partner/my-posts"],
      },
      {
        to: "/partner/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/partner/leases"],
      },
      {
        to: "/partner/saved",
        label: "Saved Properties",
        icon: FiHeart,
        activePrefixes: ["/partner/saved", "/partner/following"],
      },
      {
        to: "/partner/shared-with-me",
        label: "Shared with Me",
        icon: FiFolder,
        activePrefixes: ["/partner/shared-with-me"],
      },
    ],
  },
].map((section) => ({
  ...section,
  items: section.items.map(createItem),
}));

export const getPartnerPageTitle = (pathname) => {
  const allItems = partnerSidebarSections.flatMap((s) => s.items);
  const found = allItems.find((item) =>
    item.activePrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
  );
  return found?.label ?? "Partner Dashboard";
};

const partnerNavigation = {
  sections: partnerSidebarSections,
};

export default partnerNavigation;
